import React, { useEffect } from "react";
import { CenteredSpin } from "web/src/components/chrome/CenteredSpin";
import { DocsInterface } from "../chrome/DocsInterface";
import { useDocsLocation } from "../chrome/nav/useDocsLocation";
import { DocsRedirects } from "../redirects";

const Redirect = (props: any) => {
  const [location, setLocation] = useDocsLocation();

  useEffect(() => {
    const [path] = location.split("#", 2);
    const destination = DocsRedirects[path];
    if (destination) {
      setLocation(destination);
    } else {
      setLocation("/");
    }
  }, []);

  return (
    <DocsInterface {...props}>
      <CenteredSpin />
    </DocsInterface>
  );
};

export default Redirect;
